"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReportsRoute {
    static get path() {
        return '/reports';
    }
    static get friendlyName() {
        return 'reportHeader';
    }
}
exports.default = ReportsRoute;
